import { Routes, Route, Navigate, Outlet } from 'react-router-dom';

import { AuthHelper } from './helpers/auth.helper';

import { Auth } from './components/pages/Auth';

import { Dashboard } from './components/pages/Dashboard';

import { SubClients } from './components/pages/SubClients';
import { Cohorts } from './components/pages/Cohorts';
import { Employees } from './components/pages/Employees';
import { BulkEntitlements } from './components/pages/BulkEntitlements';
import { Settings } from './components/pages/Settings';

export const NavigationRoutes = () => {
    return (
        <Routes>
            <Route element={<AuthRoutes />}>
                <Route path="/auth" element={<Navigate to={'/auth/sign-in'} replace />} />
                <Route path="/auth/:view" element={<Auth />} />
            </Route>

            <Route element={<PrivateRoutes />}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/sub-clients" element={<SubClients />} />
                <Route path="/cohorts" element={<Cohorts />} />
                <Route path="/participants" element={<Employees />} />
                <Route path="/bulk-entitlements" element={<Navigate to="/bulk-entitlements/client" replace />} />
                <Route path="/bulk-entitlements/:source" element={<BulkEntitlements />} />
                <Route path="/settings" element={<Settings />} />
            </Route>

            <Route path="*" element={<div />} />
        </Routes>
    );
};

const PrivateRoutes = () => {
    const isAuthTokenValid = AuthHelper.isAuthTokenValid().result;

    return (
        isAuthTokenValid
            ? <Outlet />
            : <Navigate to="/auth/sign-in" />
    );
};

const AuthRoutes = () => {
    const isAuthTokenValid = AuthHelper.isAuthTokenValid().result;

    return (
        !isAuthTokenValid
            ? <Outlet />
            : <Navigate to="/" />
    );
};